import React, { useCallback, useEffect, useState, forwardRef } from "react"
import cs from "classnames"
import dayjs from "dayjs"
import ReactDatePicker from "react-datepicker"
import * as StyleSheet from "../styles.js"
import Wrapper from "../Wrapper"
import "react-datepicker/dist/react-datepicker.css"

/*
For detailed API usage, see https://reactdatepicker.com/
*/

const toDate = (value) => dayjs(value).isValid() ? dayjs(value).toDate() : null

const CalendarComponent = forwardRef(({
  name,
  label = "",
  onChange = () => null,
  theme,
  disabled = false,
  className,
  value,
  ...rest
}, ref) => {
  const [date, setDate] = useState(toDate(value))
  const styleSheet = StyleSheet[theme]?.(disabled) || StyleSheet["profile"](disabled)

  const onUserDateChange = useCallback((date) => {
    onChange(dayjs(date).format("YYYY-MM-DD"))
    setDate(date)
  }, [onChange])

  useEffect(() => {
    setDate(toDate(value))
  }, [value])

  return (
    <Wrapper label={label} className={className} name={`calendar-${name}`} styleSheet={styleSheet}>
      <ReactDatePicker
        ref={ref}
        selected={date}
        onChange={onUserDateChange}
        className={cs(styleSheet.input)}
        disabled={disabled}
        dateFormat={"yyyy-MM-dd"}
        showTimeSelect={false}
        popperClassName={"!z-50"}
        {...rest}
      />
    </Wrapper>
  )
})
CalendarComponent.displayName = "CalendarComponent"

export default CalendarComponent
